<div class="container-fluid">
  <!-- Header Section -->
  <div class="row mb-4">
    <div class="col-12">
      <div class="card shadow-sm">
        <div class="card-body">
          <div class="d-flex justify-content-between align-items-center">
            <div>
              <h2 class="mb-2">{{ config?.title }}</h2>
              <p class="text-muted mb-0" *ngIf="config?.subtitle">{{ config?.subtitle }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Main Card -->
  <div class="card position-relative">
    <!-- Loading Overlay -->
    <div class="text-center position-absolute top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center"
      style="background: rgba(255,255,255,0.6); z-index: 10;" *ngIf="loading">
      <div class="spinner-border text-primary" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    </div>
    <div class="card-body m-0">

      <!-- Advanced Dynamic Filters -->
      <app-transaction-filter (search)="onFilterSearch($event)" (reset)="onFilterReset()"></app-transaction-filter>

      <!-- Action Buttons Row -->
      <div class="row mb-2">
        <div class="col-xl-12">
          <div class="text-start">
            <button type="button" class="btn bg-danger-custom" (click)="onExportCSV()" [disabled]="loading">
              <i class="feather icon-download me-2"></i>Export CSV
            </button>

            <div class="btn-group" ngbDropdown role="group">
              <button class="btn bg-danger-custom" ngbDropdownToggle>
                <i class="feather icon-columns me-2"></i>Columns
              </button>
              <div ngbDropdownMenu class="ng-dropdown-panel-items p-1"
                style="height: 250px;width: 250px; overflow: scroll; scroll-behavior: smooth">
                <div class="form-group">
                  <div *ngIf="columnDefs" class="list-group ng-option">
                    <span *ngFor="let column of columnDefsCopy; let i = index" class="checkbox">
                      <label class="list-group-item p-2">
                        <input class="form-check-input me-1" type="checkbox"
                          style="margin-left: 180px;" value="{{i}}" name="{{column.headerName}}"
                          (change)="updateSelectedColumn($event)"
                          [checked]="(tableSelectedColumn && (-1 !==tableSelectedColumn.indexOf(column)) ? 'checked': '')" />
                        {{(column?.headerName?.replace('_','') || column?.field?.replace('_','') )}}
                      </label>
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <br>
          </div>
        </div>
      </div>

      <!-- Grid Container -->
      <div class="row mb-0" style="min-height: 470px">
        <div class="col-12 col-xl-12 grid-margin stretch-card ag-theme-alpine" style="margin-bottom: 0px">
          <ag-grid-angular [enableCellTextSelection]=true (sortChanged)="onSortChange($event)"
            (filterChanged)="onFilterChange($event)" (filterModified)="onFilterModified($event)"
            (filterOpened)="onFilterOpened($event)" (gridReady)="onGridReady($event)"
            (rowClicked)="onRowClicked($event)" (rowDoubleClicked)="onRowDoubleClicked($event)"
            (search)="globalSearch" [columnDefs]="tableSelectedColumn" [defaultColDef]="defaultColDef"
            [enableCellTextSelection]=true [paginationPageSize]="pageSize" [pagination]="true"
            [rowData]="rowData" [rowModelType]="'clientSide'" [rowSelection]="'single'" [suppressPaginationPanel]="true"
            style="width: 100%; height: auto;">
          </ag-grid-angular>
        </div>
      </div>

      <!-- Pagination and Page Size Row -->
      <div class="row mt-0">
        <div class="col-4 col-xs-4 d-flex">
          <select (change)="onPageSizeChanges($event)" [(ngModel)]="pageSize"
            class="form-select d-flex justify-content-end col-4" name="pageSize" style="width: auto">
            <option *ngFor="let pageNum of pageSizeArr" [ngValue]="pageNum">{{pageNum}}</option>
          </select>
          <p class="text-muted p-3">Total Records: {{ collectionSize }}</p>
        </div>

        <div class="col-8 col-xs-8">
          <ngb-pagination (pageChange)="onPaginationChange($event)" [(page)]="currentPage" [boundaryLinks]="true"
            [collectionSize]="collectionSize" [maxSize]="5" [pageSize]="pageSize" [rotate]="false" [directionLinks]="true"
            [ellipses]="false" size="sm" class="d-flex justify-content-end align-right">
          </ngb-pagination>
        </div>
      </div>
    </div>
  </div>

  <!-- No Data Message -->
  <div class="alert alert-info mt-4" *ngIf="!loading && (!rowData || rowData.length === 0)">
    <i class="fas fa-info-circle"></i> No transaction data available for the selected filters.
  </div>
</div>
